import { render, staticRenderFns } from "./WindowDrag.vue?vue&type=template&id=d890acda&scoped=true"
import script from "./WindowDrag.vue?vue&type=script&lang=js"
export * from "./WindowDrag.vue?vue&type=script&lang=js"
import style0 from "./WindowDrag.vue?vue&type=style&index=0&id=d890acda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d890acda",
  null
  
)

export default component.exports